import postGeneratePreview from "fetchers/postGeneratePreview";
import React, { useState } from "react";
import { saveImage } from "tools/common";
import { AttributeType } from "types";

type Props = {
  type: "make" | "generate";
  imageHeight: number;
  imageWidth: number;
  uploadedAttributes: AttributeType[];
  setUploadProgress: (progress: number) => void;
  setIsCreated: (isCreated: boolean) => void;
  resetState: () => void;
  setShowProgress: (showProgress: boolean) => void;
  setIsPreviewLoading: (isPreviewLoading: boolean) => void;
};

function usePreviewGenerator({
  type,
  imageHeight,
  imageWidth,
  uploadedAttributes,
  setUploadProgress,
  setIsCreated,
  resetState,
  setShowProgress,
  setIsPreviewLoading,
}: Props) {
  const generatePreview = async () => {
    setShowProgress(true);
    setIsPreviewLoading(true);

    let formData = new FormData();
    formData.append("isPreview", "true");
    formData.append("maxSupply", "10");
    formData.append("imageHeight", String(imageHeight));
    formData.append("imageWidth", String(imageWidth));
    uploadedAttributes.map((attribute) => {
      const filename = attribute.name;
      const files = attribute.files;
      return files.map((file) => {
        return formData.append(`${filename}`, file);
      });
    });

    await postGeneratePreview({
      uploadedAttributes,
      type,
      setUploadProgress,
      formData,
    })
      .then((res) => {
        // setPreview(URL.createObjectURL(res.data));
        // setBlobPreview(res.data);
        switch (type) {
          case "make":
            saveImage(res.data, "png", setIsCreated);
            break;
          case "generate":
            saveImage(res.data, "zip", setIsCreated);
            break;
        }
        setIsCreated(true);
        resetState();

        setIsPreviewLoading(false);
        return res;
      })
      .catch((err) => {
        setIsCreated(false);
        setIsPreviewLoading(false);
        resetState();
        // setIsPreviewLoading(false);
        if (!err.response) {
          // network error
          return Promise.reject("Error: Network Error");
        } else {
          const newBlob = new Blob([err.response.data], {
            type: "text/html",
          });
          newBlob.text().then((res) => {
            if (res.search("Error: Input stream problem, please retry") !== -1)
              // return generatePreview();
              return;

            return Promise.reject(err);
          });
        }
      });
  };

  return {
    generatePreview,
  };
}

export default usePreviewGenerator;
